import vegetarisk from '../assets/vegetarisk.jpg';
import kebabtallrik from '../assets/kebabtallrik.jpg';
import hamburgertallrik from '../assets/hamburgertallrik.jpg';
import falukorv from '../assets/falukorv.jpg';
import bacon from '../assets/bacon.jpg';
import lovbiff from '../assets/lovbiff.jpg';


export const aLaCarteMenu = [
    {
      img: hamburgertallrik,
      title: 'Oscars hamburgertallrik 200g'
    },

    {
      img: kebabtallrik,
      title: 'Kebabtallrik'
    },
    {
      img: falukorv,
      title: 'Stekt falukorv med stekt ägg och stekt potatis'
    },
    {
      img: bacon,
      title: 'Bacon med stekt ägg och stekt potatis'
    },
    {
      img: vegetarisk,
      title: 'Vegetarisk falafel'
    },
    {
      img: lovbiff,
      title: 'Lövbiff'
    }
  ]